//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation, Awards } from '/containers-m/';

//context containers
import {
  Hero,
  Services,
  IntroductionText,
  CustomersLogos,
  Featured,
  FreightSection,
  SidePanels,
  LifeLoadVideo,
  ShipWithUs,
  Newsroom,
  ImageCTA,
  LogoImageCTA,
} from './containers/index';

import { HubspotFormSimplifiedV4 } from '@/containers-m/HubspotFormSimplified';

//styles
import { PageWrapper, HubspotFormWrapper } from './HomeOld.styles';

//vendor
import { contactOptions } from '@/vendor/HubspotFormIntegration';

const form_content = {
  title: (
    <>
      Lower costs, increase efficiency, and digitize transportation with
      Loadsmart’s solutions
    </>
  ),
  subtitle: (
    <>
      Lower freight costs and boost performance with Loadsmart’s software and
      services.
    </>
  ),
};

const awards_content = {
  title:
    'Trusted by shippers. Recognized by the people who follow the industry closest.',
  tag: 'INDUSTRY RECOGNITION',
  items: [
    {
      year: '2026',
      title: 'Top Freight Brokerage',
      source: 'Transport Topics',
    },
    {
      year: '2026',
      title: 'Logistics IT Top 100',
      source: 'Inbound Logistics',
    },
    {
      year: '2025',
      title: 'FreightTech 100',
      source: 'FreightWaves',
    },
    {
      year: '2025',
      title: 'Top Workplaces',
      source: 'Chicago Tribune',
    },
    {
      year: '2024',
      title: 'Top 100 Logistics IT Providers',
      source: 'Inbound Logistics',
    },
    {
      year: '2024',
      title: 'Top Food Chain Technology',
      source: 'Food Shippers of America',
    },
    {
      year: '2024',
      title: 'Women in Supply Chain',
      source: 'SDCE — Rising Star',
    },
    {
      year: '2024',
      title: 'Crain’s Fast 50',
      source: 'Crain’s Chicago',
    },
    {
      year: '2024',
      title: '1871 CityLIGHTS',
      source: '1871 Chicago',
    },
  ],
};

function HomeOld() {
  return (
    <PageWrapper>
      <Navigation theme="dark" />
      <>
        <Hero />
        <CustomersLogos />
        <Services />
        <FreightSection />
        <IntroductionText />
        <ImageCTA />
        <LogoImageCTA />
        <Awards awards_content={awards_content} />
        <SidePanels />
        <Featured />
        <LifeLoadVideo />
        <Newsroom />
        <ShipWithUs />
        <HubspotFormWrapper id="contact-form">
          <HubspotFormSimplifiedV4
            content={form_content}
            {...contactOptions}
            disclaimer={true}
            theme="dark"
          />
        </HubspotFormWrapper>
      </>
      <Footer />
    </PageWrapper>
  );
}

export default HomeOld;
export { HomeOld };
